import * as React from "react"

export const Logo = (props) => (
  <svg
    width='40px'
    height='40px'
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={40} height={40} rx={8} fill="#17CEA2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m13.582 8.705 9.369 5.685.99-6.311c2.029 4.516 2.957 9.041 1.717 13.824-1.393 5.395-4.776 9.12-9.07 12.019l-.123-.098c.255-.36.509-.715.759-1.08 1.835-2.683 3.102-5.61 3.273-8.976.175-3.516-.842-6.667-2.594-9.593a24.638 24.638 0 0 0-4.058-5.059l-.324-.336.061-.075Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.809 6.442c1.52.192 2.27 1.038 2.13 2.399a2.076 2.076 0 0 1-.73 1.456c-.424.354-.97.499-1.5.4a1.88 1.88 0 0 1-1.415-.728 2.15 2.15 0 0 1-.435-1.61c.114-1.085 1.07-2.02 1.95-1.917"
      fill="#fff"
    />
  </svg>
)

